import useTranslation from '../../hooks/useTranslation';
import { useEffect, useRef } from 'react';

import useSelectField from 'hooks/useSelectField';

import type { FieldValues, Props } from './types';

const useData = <T extends FieldValues>({
    control,
    farmId,
    isOpen,
    isRequired = false,
    name,
    onPanelClose,
    onPanelOpen,
    ref
}: Props<T>) => {
    const prevFarmIdRef = useRef<string | undefined>(farmId ?? undefined);
    const { FIELD_IS_REQUIRED } = useTranslation();

    const selectField = useSelectField({
        control,
        isOpen,
        isRequired,
        name,
        onPanelClose,
        onPanelOpen,
        ref,
        requiredMessage: isRequired ? FIELD_IS_REQUIRED : false
    });

    const { onChange } = selectField;

    useEffect(() => {
        const prevFarmId = prevFarmIdRef.current;

        if (prevFarmId !== undefined && farmId !== prevFarmId) {
            onChange(undefined);
        }

        prevFarmIdRef.current = farmId ?? undefined;
    }, [farmId, onChange]);

    return selectField;
};

export default useData;
